// extracted by mini-css-extract-plugin
export default {"visio":"ywNbTy1kTQjDINxAI39A","shareVisio":"JA3_Q3wIQObEPgsJdL99"};